import { env } from '@/config/env';

/**
 * delete-generation принимает generationId query-параметром, а не телом —
 * supabase.functions.invoke() такого не умеет (нет опции query), поэтому
 * обычный fetch с точным контрактом эндпоинта.
 */
export async function deleteGeneration(generationId: string, accessToken: string): Promise<void> {
  const url = `${env.VITE_SUPABASE_URL}/functions/v1/delete-generation?generationId=${encodeURIComponent(generationId)}`;

  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      apikey: env.VITE_SUPABASE_ANON_KEY,
    },
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: { message?: string } } | null;
    throw new Error(body?.error?.message ?? 'Не удалось удалить генерацию.');
  }
}
